import { IQuoteSection } from 'types/quote'

const First = ({ }: IQuoteSection) => {
    return (
        <>
            <p className='mb-3 font-semibold text-3xl'>견적요청</p>

            {/* <div className='flex items-center bg-white px-10 rounded-lg h-30'>
                <p className='w-[123px] text-lg'>견적명 입력 <span className='text-red'>*</span></p>
                <CustomInput
                    className="flex-[1]"
                    placeholder="견적서 제출을 위한 견적명을 입력해주세요."
                    onChange={(e) => {
                        setQuoteInfo(p => ({
                            ...p,
                            quoteName: e.target.value
                        }))
                    }}
                    value={quoteInfo.quoteName ?? ''}
                    type="text"
                />
            </div> */}
        </>
    )
}

export default First